import { Button, Container, Group, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { replace, useNavigate } from 'react-router';
import styles from './ErrorPage.module.css';

const ErrorPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation( 'error' );
  return (
    <Container className={styles.root}>
      <div className={styles.label}>Oops...</div>
      <Title className={styles.title}>{t( 'error_page_title', 'Algo Salió mal' )}</Title>
      <Text c="dimmed" size="lg" ta="center" className={styles.description}>
        {t( 'error_page_message', 'Hubo un error en el proceso de la solicitud, sugerimos que vuelva a la página de inicio.' )}
      </Text>
      <Group justify="center">
        <Button variant="subtle" size="md" onClick={() => navigate( '/', { replace: true })} >
          {t( 'back_button', 'Volver' )}
        </Button>
      </Group>
    </Container>
  );
};

export default ErrorPage;
